import React from 'react'
import { Link } from 'react-router-dom'
import Layout from '../component/Layout/Layout'
import GoogleReviews from '../pages/GoogleReviews'
import { useState } from 'react';
import { useEffect } from 'react';

function Reviews() {
    const [showReviews, setShowReviews] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowReviews(true);
        }, 10000); // 7 seconds

        return () => clearTimeout(timer); // clean up
    }, []);
    return (
        <Layout title="Reviews : Chaashni Couture" description="Chaashni Couture: Reviews" >
            <div className="site-content-wrap static-page">
                <div className="container">
                    <div className="row">
                        {!showReviews && (
                            <div className='loading-div'> <span>Loading...</span></div>
                        )}
                        <div className="col-md-12">
                            {showReviews && (
                                <>
                                    {/* <h1 className="sustom-heading-h1">Reviews </h1> */}
                                    <div className="content-box">
                                        <GoogleReviews />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Reviews
